module.exports = __webpack_public_path__ + "img/low_stock_report.ef1d579d.png";